import { Module } from 'vuex'
import { RootState } from '../types'
import { ChatState } from './types'
import { state } from './state'
import { mutations } from './mutations'
import { actions } from './actions'

export const chat: Module<ChatState, RootState> = {
  namespaced: true,
  state,
  mutations,
  actions
}
